export default "__VITE_ASSET__70988dde__"